import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function Support(){

  const [selectedDateTime, setSelectedDateTime] = useState(new Date().toISOString().slice(0,16));
  const [hospData, setHospData] = useState([]);
  const [user, setUser] = useState([]);
  const [supportData,setsupportData]=useState({
        "subject":'',
        "description":'',
        "attachment":'',
        "raised":'',
        "email":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  useEffect(() => {
            try {
              axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
              });
            } catch (error) {
              console.log(error);
            }
  },[]);
  const handleMessChange = (event, index) => {
  if (event.target.name === 'email') {
    const updatedHospData = [...hospData];
    updatedHospData[index] = {
      ...updatedHospData[index],
      email: event.target.value
    };
    setHospData(updatedHospData);
  } else {
    setsupportData({
      ...supportData,
      [event.target.name]: event.target.value
    });
  }
  };

  const handleFileChange = (event) => {
        setsupportData({
            ...supportData,
            [event.target.name]:event.target.files[0]
        });
    }
    const formSubmitmed = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const subject = document.getElementById("subject").value;
          const email = document.getElementById("email-0").value;
          if(supportData.f_files){
            _formData.append('attachment', supportData.f_files, supportData.f_files.name);
          }
          _formData.append('raised', selectedDateTime);
          _formData.append('email', email);
          _formData.append('subject', supportData.subject);
          _formData.append('description', supportData.description);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}support-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Support Message Sent.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/support/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to Send Message. Please try again later.',
                'error'
              );
            });
  };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-headset"
        aria-hidden="true" style={{color: 'red'}}></i> Tech Support</h3>
    <div className="row mt-4">
    <form>
    <div className="table-responsive">
       <table className="erp-table-modern">
        <tbody>

          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>User Name: </td>
            <td>
             <input type="text" value={userName} readOnly/>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Raise Time: </td>
            <td>
             <input type="text" className="no-comma" name="raised" id="raised"
                value={selectedDateTime}
                onChange={handleMessChange} readOnly/>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Subject : </td>
            <td>
            <select name="subject" id="subject" value={supportData.subject} onChange={handleMessChange}>
               <option value="">Select Query Type</option>
               <option value="Billing Related">Billing Related Queries</option>
			   <option value="Features Related">Features Related Queries</option>
			   <option value="Customization Related">Customization Related</option>
               <option value="Bug Related">Bug Related</option>
			   <option value="Customer Support">Customer Support Related</option>
            </select>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <td>Email Id: </td>
          <td>
            {hospData.map((hosp, index) => (
              <input
                key={index}
                type="text"
                name="email"
                id={`email-${index}`}
                value={hosp.email}
                onChange={(e) => handleMessChange(e, index)}
              />
            ))}
          </td>
        </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Upload :</td>
            <td>
          <input type="file" className="form-control" name="f_files"
            onChange={handleFileChange} id="f_files" />
          </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Enter Information : </td>
            <td>
             <textarea rows="10" style={{ width: '500px' }} name="description" id="description"
                value={supportData.description}
                onChange={handleMessChange} >
             </textarea>
            </td>
          </tr>
      </tbody>
    </table>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <button style={{ padding: '10px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
     onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
     </div>
    </form>
    </div>
    </section>
  )
}
export default Support;
